/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskGlassdoorRating
 */
export interface ExecRiskGlassdoorRating {
    /**
     * 
     * @type {number}
     * @memberof ExecRiskGlassdoorRating
     */
    overall_rating?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskGlassdoorRating
     */
    review_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskGlassdoorRating
     */
    ceo_rating?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskGlassdoorRating
     */
    recommend_to_friend?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskGlassdoorRating
     */
    culture_values?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskGlassdoorRating
     */
    diversity_inclusion?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskGlassdoorRating
     */
    oppotunities?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskGlassdoorRating
     */
    work_life_balance?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskGlassdoorRating
     */
    senior_management?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskGlassdoorRating
     */
    compensation_benefits?: number;
    /**
     * 
     * @type {number}
     * @memberof ExecRiskGlassdoorRating
     */
    business_outlook?: number;
}

/**
 * Check if a given object implements the ExecRiskGlassdoorRating interface.
 */
export function instanceOfExecRiskGlassdoorRating(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskGlassdoorRatingFromJSON(json: any): ExecRiskGlassdoorRating {
    return ExecRiskGlassdoorRatingFromJSONTyped(json, false);
}

export function ExecRiskGlassdoorRatingFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskGlassdoorRating {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'overall_rating': !exists(json, 'overall_rating') ? undefined : json['overall_rating'],
        'review_count': !exists(json, 'review_count') ? undefined : json['review_count'],
        'ceo_rating': !exists(json, 'ceo_rating') ? undefined : json['ceo_rating'],
        'recommend_to_friend': !exists(json, 'recommend_to_friend') ? undefined : json['recommend_to_friend'],
        'culture_values': !exists(json, 'culture_values') ? undefined : json['culture_values'],
        'diversity_inclusion': !exists(json, 'diversity_inclusion') ? undefined : json['diversity_inclusion'],
        'oppotunities': !exists(json, 'oppotunities') ? undefined : json['oppotunities'],
        'work_life_balance': !exists(json, 'work_life_balance') ? undefined : json['work_life_balance'],
        'senior_management': !exists(json, 'senior_management') ? undefined : json['senior_management'],
        'compensation_benefits': !exists(json, 'compensation_benefits') ? undefined : json['compensation_benefits'],
        'business_outlook': !exists(json, 'business_outlook') ? undefined : json['business_outlook'],
    };
}

export function ExecRiskGlassdoorRatingToJSON(value?: ExecRiskGlassdoorRating | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'overall_rating': value.overall_rating,
        'review_count': value.review_count,
        'ceo_rating': value.ceo_rating,
        'recommend_to_friend': value.recommend_to_friend,
        'culture_values': value.culture_values,
        'diversity_inclusion': value.diversity_inclusion,
        'oppotunities': value.oppotunities,
        'work_life_balance': value.work_life_balance,
        'senior_management': value.senior_management,
        'compensation_benefits': value.compensation_benefits,
        'business_outlook': value.business_outlook,
    };
}

